import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { isValidUrl, ButtonType } from 'wix-rich-content-common';
import { PluginToolbarButtons } from '../../../enums';
import { Modals } from '../modals';
import { Link, Edit, Refresh } from '../../../components/icons';
import i18next from 'i18next';
const defaultButtons = [
    PluginToolbarButtons.BEST_FIT,
    PluginToolbarButtons.FULL_WIDTH,
    PluginToolbarButtons.ALIGN_LEFT,
    PluginToolbarButtons.ALIGN_RIGHT,
    PluginToolbarButtons.SEPARATOR,
    PluginToolbarButtons.LINK,
    PluginToolbarButtons.SEPARATOR,
    PluginToolbarButtons.REPLACE,
    PluginToolbarButtons.DELETE
];
const configurableButtons = {
    [PluginToolbarButtons.BEST_FIT]: {
        keyName: 'sizeContent',
        type: ButtonType.SIZE_CONTENT,
        mobile: false
    },
    [PluginToolbarButtons.FULL_WIDTH]: {
        keyName: 'sizeFullWidth',
        type: ButtonType.SIZE_FULL_WIDTH,
        mobile: false
    },
    [PluginToolbarButtons.ALIGN_LEFT]: {
        keyName: 'sizeSmallLeft',
        type: ButtonType.SIZE_SMALL_LEFT,
        mobile: false
    },
    [PluginToolbarButtons.ALIGN_RIGHT]: {
        keyName: 'sizeSimallRight',
        type: ButtonType.SIZE_SMALL_RIGHT,
        mobile: false
    },
    [PluginToolbarButtons.LINK]: {
        keyName: 'link',
        type: ButtonType.EXTERNAL_MODAL,
        icon: Link,
        componentData: {
            title: i18next.t('editor.image.modal.link.title'),
            description: i18next.t('editor.image.modal.link.description'),
            placeholder: i18next.t('editor.image.modal.link.placeholder'),
            showRemoveLink: true,
            validateUrl,
            getUrl,
            updateUrl
        },
        modalName: Modals.IMAGE_LINK,
        mobile: false,
        tooltipTextKey: 'TextLinkButton_Tooltip'
    },
    [PluginToolbarButtons.SEPARATOR]: {
        keyName: 'separator',
        type: ButtonType.SEPARATOR,
        mobile: false
    },
    [PluginToolbarButtons.REPLACE]: {
        keyName: 'replace',
        icon: Edit,
        type: ButtonType.FILES,
        mobile: true,
        tooltipTextKey: 'ReplaceImageButton_Tooltip'
    },
    [PluginToolbarButtons.DELETE]: {
        keyName: 'delete',
        type: ButtonType.DELETE,
        mobile: true
    },
    [PluginToolbarButtons.REFRESH]: {
        keyName: 'refresh',
        type: ButtonType.CUSTOM,
        icon: Refresh,
        onClick: async (helpers, store)=>{
            const currentData = store.get('componentData');
            if (!currentData || !currentData.data || !currentData.data.deviationId || !helpers.fetchFreshDeviationData) {
                alert('Failed to get data for the update');
                return;
            }
            try {
                const freshData = await helpers.fetchFreshDeviationData([
                    currentData.data.deviationId
                ]);
                store.set('componentData', _object_spread_props(_object_spread({}, currentData), {
                    data: freshData[0]
                }));
            } catch (e) {
                alert('Failed to fetch updated deviation data');
            }
        },
        mobile: true,
        tooltipTextKey: 'editor.imagePlugin.refresh.tooltip'
    }
};
function getUrl(pubsub) {
    const { config: { link  }  } = pubsub.get('componentData');
    return link ? link.url : '';
}
function updateUrl(url, pubsub, helpers) {
    const link = url ? {
        url,
        target: '_blank',
        rel: 'nofollow'
    } : null;
    pubsub.update('componentData', {
        config: {
            link
        }
    });
    if (helpers && helpers.onVideoSelected) {
        helpers.onVideoSelected(url, (data)=>pubsub.update('componentData', {
                metadata: _object_spread({}, data)
            }));
    }
}
function validateUrl(url) {
    return !url || isValidUrl(url);
}
export default (({ pluginConfig , helpers  })=>{
    var _pluginConfig_toolbarButtons;
    const buttons = (_pluginConfig_toolbarButtons = pluginConfig.toolbarButtons) !== null && _pluginConfig_toolbarButtons !== void 0 ? _pluginConfig_toolbarButtons : defaultButtons;
    // If we only have one button toggle remove it
    let hasFullWidth = buttons.find((b)=>b === PluginToolbarButtons.FULL_WIDTH) !== undefined;
    const hasBestFit = buttons.find((b)=>b === PluginToolbarButtons.BEST_FIT) !== undefined;
    const hasLeftRightAlign = buttons.find((b)=>b === PluginToolbarButtons.ALIGN_LEFT || b === PluginToolbarButtons.ALIGN_RIGHT);
    const remove = {};
    if (hasFullWidth && !hasBestFit && !hasLeftRightAlign) {
        remove[PluginToolbarButtons.FULL_WIDTH] = true;
        hasFullWidth = false;
    }
    if (!hasFullWidth && hasBestFit && !hasLeftRightAlign) {
        remove[PluginToolbarButtons.BEST_FIT] = true;
    }
    if (!helpers.featureFlags['editor_refresh']) {
        remove[PluginToolbarButtons.REFRESH] = true;
    }
    return buttons.filter((button)=>!!configurableButtons[button]).filter((button)=>remove[button] ? false : true).filter((button, idx)=>idx === 0 && button === PluginToolbarButtons.SEPARATOR ? false : true).map((button)=>{
        // Allow consumer to conditionally enable/disable the link tool..
        if (pluginConfig.canBeLinked && button === PluginToolbarButtons.LINK) {
            const link = configurableButtons[button];
            link.mapComponentDataToButtonProps = (componentData)=>{
                return {
                    disabled: pluginConfig.canBeLinked(componentData, helpers.currentUser) === false
                };
            };
            return link;
        }
        if (pluginConfig.canBeFullWidth && button === PluginToolbarButtons.FULL_WIDTH) {
            const fullWidth = configurableButtons[button];
            fullWidth.mapComponentDataToButtonProps = (componentData)=>{
                return {
                    disabled: pluginConfig.canBeFullWidth(componentData) === false
                };
            };
        }
        const configButton = configurableButtons[button];
        if (button === PluginToolbarButtons.REFRESH && !configButton.isBound) {
            configButton.onClick = configButton.onClick.bind(configButton, helpers);
            configButton.isBound = true;
        }
        return configButton;
    });
});
